import _ from 'lodash';
import common from '../utility/common';
import moment from 'moment';

/* eslint-disable */
var sortByPropertyCompareFunction = function (a, b, property) {
  const propA = a[property] ? a[property].toString().toLowerCase() : '';
  const propB = b[property] ? b[property].toString().toLowerCase() : '';

  return (propA < propB) ? -1 : (propA > propB) ? 1 : 0;
};

Set.prototype.isSuperset = function (subset) {
  for (var elem of subset) {
    if (!this.has(elem)) {
      return false;
    }
  }
  return true;
}

Set.prototype.intersection = function (setB) {
  var intersection = new Set();
  for (var elem of setB) {
    if (this.has(elem)) {
      intersection.add(elem);
    }
  }
  return intersection;
}

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
};

export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1);
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return null;
};

export function removeCookie(cname) { this.setCookie(cname, "", -1); };
// API Helpers
//-------------------------
export function determineActiveMeal(meals, dateTime) {
  var activeMeal = meals.find(function (meal) {
    if (dateTime.isAfter(meal.Hours.StartTime) && dateTime.isBefore(meal.Hours.EndTime)) { return meal; }
  }.bind(this));

  // Otherwise determine what next upcoming meal period is
  if (typeof activeMeal === "undefined") {
    activeMeal = meals.slice().find(function (meal) { if (dateTime.isBefore(meal.Hours.StartTime)) { return meal; } })
  }

  return activeMeal;
};
export function getDateForParams(params) {
  let date;
  if (params && params.year && params.month && params.day) {
    date = moment([params.year, params.month - 1, params.day]);
  }
  else {
    date = moment();
  }
  return date ? date : moment();
};

export function getLocationByName(locations, locationName) {
  return locations.find(function (location) {
    if (location.Name === locationName) {
      return location;
    }
  });
};

export function getLocationForParams(params) {
  return params.locationName || null;
};

export function getMealForParams(params, meals) {
  var isMealSet = false;
  var currentMeal = null;
  var firstMeal = meals[0].Name;
  if (params.meal) {
    return params.meal;
  }
  else {
    meals.forEach(function (a, i) {
      if (moment().isBetween(a.Hours.StartTime, a.Hours.EndTime, null, '[]')) {
        isMealSet = true;
        currentMeal = a.Name;
      }
      else if (isMealSet === false && moment().isBefore(a.Hours.StartTime)) {
        isMealSet = true;
        currentMeal = a.Name;
      }
    });
    if (currentMeal === null) {
      return firstMeal;
    }
    else {
      return currentMeal;
    }
  }
  //return params.meal || cookies.get("selectedMeal") || "Breakfast";
};

export function getMealByName(meals, mealName) {
  return meals.find(function (meal) {
    return meal.Name === mealName;
  });
};

// Sorting
//-------------------------
export function sort_by(array, order, key) {
  return _.sortBy(array, function (obj) {
    return _.indexOf(order, obj[key])
  });
};

export function sort_by_days(array, order, key) {
  return _.sortBy(array, function (obj) {
    return _.indexOf(order, obj[key])
  });
};

export function sort_by_hours(array, order, key) {
  return _.sortBy(array, function (obj) {
    return _.indexOf(order, obj[key])
  });
};

// Debounce Function
//-------------------------
export function debounce(fn, delay) {
  var timer = null;

  return function () {
    var context = this, args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};
export function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last,
    deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date,
      args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
};
export function jumpPageToTop() {
  if (document.getElementsByClassName("mdl-layout").length > 0) { document.getElementsByClassName("mdl-layout")[0].scrollTop = 0; }
}


export function logOut() {
  const thisPage = window.location.href;
  window.location.href = common.baseUrl + "Home/Logout?redirectUrl=" + encodeURIComponent(thisPage);
}

// export function logIn() {
//   const currentPage = window.location.href;
//   const loginUrl = `https://api.hfs.purdue.edu/Menus/home/login?redirect=${encodeURIComponent(currentPage)}`;
//   window.location.href = loginUrl;
// }

// Log in function based off of dining administration's implementation. Redirects to Purdue's SSO login page, then back to the current page after logging in.
export function logIn() {
  const thisPage = window.location.href;
  const service = common.baseUrl + "Home/CasRedirect?redirectUrl=" + encodeURIComponent(thisPage);
  window.location.href = "https://sso.purdue.edu/idp/profile/cas/login?service=" + encodeURIComponent(service);
}